module.exports = __webpack_public_path__ + "static/media/sukajadi.228d8f39.jpg";